<ng-container *transloco="let t">
  <div class="pt-32-15 pb-300-100">

    @if (!isMobile) {
      <div class="row">
        <div class="col-md-8 d-flex flex-column gap-3">
          <ng-template [ngTemplateOutlet]="leagueInfo"></ng-template>
          <ng-template [ngTemplateOutlet]="scoringAndRanking"></ng-template>
          <ng-template [ngTemplateOutlet]="leagueRulesPdf"></ng-template>
        </div>
        <div class="col-md-4 d-flex flex-column gap-3">
          <ng-template [ngTemplateOutlet]="organizers"></ng-template>
        </div>
      </div>
    } @else {
      <div class="d-flex flex-column gap-3">
        <ng-template [ngTemplateOutlet]="leagueInfo"></ng-template>
        <ng-template [ngTemplateOutlet]="scoringAndRanking"></ng-template>
        <ng-template [ngTemplateOutlet]="leagueRulesPdf"></ng-template>
        <ng-template [ngTemplateOutlet]="organizers"></ng-template>
      </div>
    }
    <ng-template #leagueInfo>
      <div class="d-flex flex-column gap-2">
        <p *ngIf="!isMobile" class="title"> {{ t('league.info.general') }} </p>
        <div class="league-section">
          <p *ngIf="isMobile" class="title"> {{ t('league.info.general') }} </p>
          <div class="expandable-text pt-2">
            <div class="content color-slate-600"
                 [class.collapsed]="!generalInfoExpanded"
                 [style.--collapsed-lines]="isMobile ? 10 : 20"
                 [style.text-align]="'justify'">
              <app-language-output [multiLangValue]="league?.generalInfo"
                                   [languages]="languages" [showAsInnerHtml]="true"
                                   [defaultLabel]="t('race.details.empty')"
              />
            </div>

            <div class="d-flex justify-content-center pt-3">
              <app-button-alt (onClickCallback)="toggleGeneral()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                              [text]="t(generalInfoExpanded ? 'app.common.show.less' : 'race.details.read.more')" [borderColor]="'transparent'"
                              [trailingIcon]="(generalInfoExpanded ? 'assets/icons/icons-alt/chevron_up_alt.svg' : 'assets/icons/icons-alt/chevron_down_alt.svg')"
                              [trailingIconSize]="'16px'" [textTransform]="'none'" [fontSize]="'14px'"
              ></app-button-alt>
            </div>

          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #scoringAndRanking>
      <div class="d-flex flex-column gap-2">
        <p *ngIf="!isMobile" class="title"> {{ t('league.info.scoring') }} </p>
        <div class="league-section">
          <p *ngIf="isMobile" class="title"> {{ t('league.info.scoring') }} </p>
          <div class="expandable-text pt-2">
            <div class="content color-slate-600"
                 [class.collapsed]="!scoringExpanded"
                 [style.--collapsed-lines]="isMobile ? 10 : 20"
                 [style.text-align]="'justify'">
              <app-language-output [multiLangValue]="league?.scoringInfo"
                                   [languages]="languages" [showAsInnerHtml]="true"
                                   [defaultLabel]="t('race.details.empty')"
              />
            </div>

            <div class="d-flex justify-content-center pt-3">
              <app-button-alt (onClickCallback)="toggleScoring()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                              [text]="t(scoringExpanded ? 'app.common.show.less' : 'race.details.read.more')" [borderColor]="'transparent'"
                              [trailingIcon]="(scoringExpanded ? 'assets/icons/icons-alt/chevron_up_alt.svg' : 'assets/icons/icons-alt/chevron_down_alt.svg')"
                              [trailingIconSize]="'16px'" [textTransform]="'none'" [fontSize]="'14px'"
              ></app-button-alt>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #leagueRulesPdf>
      <div class="d-flex flex-column gap-2">
        <p *ngIf="!isMobile" class="title"> {{ t('league.details.rules') }} </p>
        <div class="league-section">
          <div class="d-flex justify-content-between align-items-center">
            <div *ngIf="isMobile" class="d-flex align-items-center gap-2 flex-grow-1">
              <img src="assets/icons/icons-alt/trusted-badge.svg" alt="Rules" width="18" height="18"/>
              <p class="title">{{ t('league.details.rules') }}</p>
            </div>
  <!--          <div (click)="downloadRulesPdf()" class="d-flex justify-items-start align-items-center gap-2 cursor-pointer">-->
  <!--            <p class="color-teal-500"> {{ t('league.info.open.pdf') }} </p>-->
  <!--            <img src="assets/icons/icons-alt/external-link.svg" alt="Link" class="card-body__icon p-1 ps-0"/>-->
  <!--          </div>-->
          </div>
          <div class="expandable-text pt-2">
            <div class="content color-slate-600"
                 [class.collapsed]="!rulesExpanded"
                 [style.--collapsed-lines]="isMobile ? 10 : 20"
                 [style.text-align]="'justify'">
              <app-language-output [multiLangValue]="league?.rules"
                                   [languages]="languages" [showAsInnerHtml]="true"
                                   [defaultLabel]="t('race.details.empty')"
              />
            </div>

            <div class="d-flex justify-content-center pt-3">
              <app-button-alt (onClickCallback)="toggleRules()" [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'35px'"
                              [text]="t(rulesExpanded ? 'app.common.show.less' : 'race.details.read.more')" [borderColor]="'transparent'"
                              [trailingIcon]="(rulesExpanded ? 'assets/icons/icons-alt/chevron_up_alt.svg' : 'assets/icons/icons-alt/chevron_down_alt.svg')"
                              [trailingIconSize]="'16px'" [textTransform]="'none'" [fontSize]="'14px'"
              ></app-button-alt>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #organizers>
      <div class="d-flex flex-column gap-2">
        <p *ngIf="!isMobile" class="title invisible"> organizers </p>
        <div class="league-section d-flex flex-column gap-2">
          <p class="fs-14 fw-400 color-slate-600"> {{ t('league.overview.organized.by') | uppercase }} </p>
          <div class="d-flex gap-3 align-items-center overflow-hidden">
            <!--@if (league?.organiser?.image) {
            <div class="organiser-logo flex-shrink-0">
                <img src="{{league?.organiser?.image|| ''}}" alt="Organiser Image">
             </div>
            }-->
            <div class="d-flex flex-column gap-3 overflow-hidden w-100">
              <div class="d-flex align-items-center gap-2">
                <!--<div class="league-section teal d-flex align-items-center justify-content-center fs-14-16">1</div>-->
                <p class="fw-500 mb-0"> {{ league?.organiser?.name }} </p>
              </div>

              <div class="divider-horizontal"></div>

              <div class="d-flex align-items-center gap-2">
                <img src="assets/icons/icons-alt/world.svg" alt="Globe" width="22" height="22"/>
                <div class="d-flex flex-column align-items-start">
                  <p class="fs-12">{{ t('app.common.official.page') }}</p>
                  <p class="fw-500 fs-14"> {{ league?.officialWebsite }} </p>
                </div>
              </div>

              <div class="divider-horizontal"></div>

              <div class="d-flex align-items-center gap-2">
                <img src="assets/icons/icons-alt/email-alt.svg" alt="Email" width="22" height="22"/>
                <div class="d-flex flex-column align-items-start">
                  <p class="fs-12">{{ t('app.common.contact.email') }}</p>
                  @if (league?.officialMail) {
                    <div class="d-flex align-items-center color-slate-600 organiser-mail">
                      <span class="pe-1 flex-shrink-0">E:</span>
                      <a href="mailto:{{league?.officialMail ?? ''}}">{{ league?.officialMail ?? "" }}</a>
                    </div>
                  }
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </ng-template>

<!--    <ng-template #socialMedia>-->
<!--      <div class="league-section">-->
<!--        <div class="d-flex flex-column gap-2 justify-content-center align-items-center">-->
<!--          <p class="fs-14 fw-400 color-slate-600"> {{ t('league.info.follow.us') | uppercase }} </p>-->
<!--          <div class="d-flex align-items-center gap-2">-->
<!--            @for(media of socialMediaLinks; track $index) {-->
<!--              <div class="d-flex align-items-center">-->
<!--                <img (click)="openSocialMedia(media.url)" [src]="media.icon" alt="Media" class="card-body__icon p-1 ps-0" style="height: 44px; width: 44px;"/>-->
<!--              </div>-->
<!--            }-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </ng-template>-->
    <!--<div class="row">
      <div class="col-12">
        <app-section-subtitle [subtitle]="t('app.common.description')"/>-->
<!--        <div class="vertical-21-bottom">
          <img src="{{currentEventItem?.descriptionImage}}" alt="Event description image..." class="img-fluid"/>
        </div>-->
    <!--<app-entry-list-item>
      <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="currentEventItem?.description"
                           [enLabel]="currentEventItem?.descriptionEng"
                           [srLabel]="currentEventItem?.descriptionSr"
                           [bsLabel]="currentEventItem?.descriptionBs"
                           [itLabel]="currentEventItem?.descriptionIta" [siLabel]="currentEventItem?.descriptionSlo"
                           [defaultLanguage]="currentEventItem?.defaultLanguage"
                           [defaultLabel]="t('event.details.empty')" [languages]="languages"/>
    </app-entry-list-item>
    <app-section-subtitle [subtitle]="t('event.info.rules')"/>-->
<!--        <div class="vertical-21-bottom">
      <img src="{{currentEventItem?.rulesImage}}" alt="Event rules image..." class="img-fluid"/>
    </div>-->
    <!--<app-entry-list-item>
      <app-language-output [showAsInnerHtml]="getLabel()" [hrLabel]="currentEventItem?.rules"
                           [enLabel]="currentEventItem?.rulesEng"
                           [srLabel]="currentEventItem?.rulesSr"
                           [bsLabel]="currentEventItem?.rulesBs"
                           [itLabel]="currentEventItem?.rulesIta" [siLabel]="currentEventItem?.rulesSlo"
                           [defaultLanguage]="currentEventItem?.defaultLanguage"
                           [defaultLabel]="t('event.rules.details.empty')" [languages]="languages"/>
    </app-entry-list-item>
  </div>-->
<!--      <div class="col-12 col-xxl-4 order-1 order-xxl-2">-->
<!--        <app-section-subtitle [subtitle]="t('event.info.mediaContent')"/>-->
<!--        <app-entry-list-item>-->
<!--          <div>-->
<!--            <app-language-output [hrLabel]="currentEventItem?.mediaContentHor"-->
<!--                                 [enLabel]="currentEventItem?.mediaContentHorEng"-->
<!--                                 [itLabel]="currentEventItem?.mediaContentHorIta"-->
<!--                                 [siLabel]="currentEventItem?.mediaContentHorSlo"-->
<!--                                 [defaultLanguage]="currentEventItem?.defaultLanguage"-->
<!--                                 [defaultLabel]="t('event.mediaContentHor.details.empty')" [languages]="languages"/>-->
<!--            <app-youtube-embed [youtubeUrl]="mediaVideoHor"/>-->
<!--          </div>-->
<!--          <div>-->
<!--            <app-language-output [hrLabel]="currentEventItem?.mediaContentVert"-->
<!--                                 [enLabel]="currentEventItem?.mediaContentVertEng"-->
<!--                                 [itLabel]="currentEventItem?.mediaContentVertIta"-->
<!--                                 [siLabel]="currentEventItem?.mediaContentVertSlo"-->
<!--                                 [defaultLanguage]="currentEventItem?.defaultLanguage"-->
<!--                                 [defaultLabel]="t('event.mediaContentVert.details.empty')" [languages]="languages"/>-->
<!--            <app-youtube-embed [youtubeUrl]="mediaVideoVert"/>-->
<!--          </div>-->
<!--        </app-entry-list-item>-->
<!--        <div class="d-none d-xxl-flex">-->
<!--          <ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-12 order-3">-->
<!--        <div class="d-flex w-100 d-xxl-none">-->
<!--          <ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>-->
<!--        </div>-->
<!--      </div>-->
    <!-- </div>-->
  </div>
   <ng-template #galleryTemplate>
     <app-section-subtitle [subtitle]="t('event.info.Gallery')" [isSmall]="true"/>
     <app-entry-list-item/>
   </ng-template>
 </ng-container>
